import { useRouter } from "next/router";
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

interface DynamicTranslationsContextValue {
  translations: Record<string, string>;
  setTranslations: (translations: Record<string, string>) => void;
}

const DynamicTranslationsContext =
  createContext<DynamicTranslationsContextValue>({
    translations: {},
    setTranslations: () => {},
  });

export function DynamicTranslationsProvider({
  children,
  initialTranslations = {},
}: {
  children: ReactNode;
  initialTranslations?: Record<string, string>;
}) {
  const router = useRouter();
  const [translations, setTranslations] =
    useState<Record<string, string>>(initialTranslations);

  // Reset translations when locale changes (in case pageProps hasn't updated yet)
  useEffect(() => {
    setTranslations(initialTranslations);
  }, [router.locale, initialTranslations]);

  return (
    <DynamicTranslationsContext.Provider
      value={{ translations, setTranslations }}
    >
      {children}
    </DynamicTranslationsContext.Provider>
  );
}

export function useDynamicTranslationsContext() {
  return useContext(DynamicTranslationsContext);
}
